<template>
  <div class="joinus_index">
    <div class="banner" id="join_us">
    </div>
    <div class="join_us_inf join_us_c">
      <div class="center">
        <div class="title_box">
          <p>
            来这里
            </br>
            你会感受创业者无时不在的不灭激情
            </br>
            年轻人不受束缚的创想活力
            </br>
            以独到细节入心的人文关怀公司与时俱进的前沿洞察力
            </br>
            …
            </br>
            来吧
            </br>
            与最优秀的人一起做最有意义的事
            </br>
            期待你的加入

          </p>
        </div>
        <h1 class="title_h1">假如你需要更多理由</h1>
        <div class="join_reason clearfix">
          <span>
            <img src="http://static.adjuz.net/newsite/images/join_us_1.png" alt="">
          </span>
          <span>
            <img src="http://static.adjuz.net/newsite/images/join_us_2.png" alt="">
          </span>
          <span>
            <img src="http://static.adjuz.net/newsite/images/join_us_3.png" alt="">
          </span>
          <span>
            <img src="http://static.adjuz.net/newsite/images/join_us_4.png" alt="">
          </span>
        </div>
        <h1 class="title_h1">工作机会</h1>
        <div class="join_us_text_box" v-for="(ele,index) in list" :key="index">
          <div class="join_us_text clearfix">
            <div class="font_module module_l">
              <h3>{{ele[0].name}}</h3>
              <h5>工作职责：</h5>
              <p v-for="(j,q) in ele[0].duty">{{j}}</p>
              <h5 class="margin_t_35">岗位要求：</h5>
              <p v-for="(j,q) in ele[0].requirement">{{j}}</p>
              <h5 class="margin_t_35">工作地点：</h5>
              <p v-for="(j,q) in ele[0].place">{{j}}</p>
            </div>
            <div class="font_module module_r">
              <h3>{{ele[1].name}}</h3>
              <h5>工作职责：</h5>
              <p v-for="(j,q) in ele[1].duty">{{j}}</p>
              <h5 class="margin_t_35">岗位要求：</h5>
              <p v-for="(j,q) in ele[1].requirement">{{j}}</p>
              <h5 class="margin_t_35">工作地点：</h5>
              <p v-for="(j,q) in ele[1].place">{{j}}</p>
            </div>
          </div>
        </div>
        <p class="email_adress">请发送简历至招聘邮箱 <a href="javascript:;">liman@adjuz.net</a>，邮件主题为：“地点+职位+姓名”</p>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
export default {
  name: "",

  data() {
    return {
      list: [
        [
          {
            name: "移动广告销售经理（北京/广州）",
            duty: [
              "1.积分墙、ASO、ASA 苹果竞价等Appstore各方面的销售，开拓新客户，建立维系长期合作关系；",
              "2.安卓ios各种形式流量整合服务，为客户提供专业的业务咨询，与策划合作为客户提供优化、推广方案；",
              "3.对投放效果进行数据跟踪, 效果分析, 策略优化；",
              "4.制定广告创意，负责广告素材的协调和跟踪优化；",
              "5.跟踪市场广告投放的情况，对业内相关产品和竞争对手进行监测及数据分析。",
            ],
            requirement: [
              "1.本科以上学历，有苹果appstore推广工作经验优先，没经验有潜质者可以带；",
              "2.熟悉移动互联网行业，熟悉各种移动市场、论坛、手机厂商或运营商渠道。熟悉iOS和Android平台及App产品；",
              "3.优秀的逻辑思维能力、沟通能力、抗压能力；",
              "4.对数据敏感，能理清各项指标之间的关系，能敏锐感知数据的变化, 懂得数据驱动的工作方式； ",
              "5.良好的抽象思维能力，良好的逻辑能力，工作有方法；",
              "6.熟悉移动互联网领域的商业模式，熟悉移动应用市场的现状和发展；",
              "7.熟悉移动互联网应用产品市场，对移动互联网的各运营平台、主流产品有较深理解和认识优先考虑。",
            ],
            place: ["北京总部：北京市丰台区汉威国际广场三区一号楼9M层"],
          },
          {
            name: "海外广告销售高级经理（北京）",
            duty: [
              "1.负责国内公司出海如游戏APP等，完成公司所制定的销售指标；",
              "2.跟踪及处理客户反馈，维护并拓展广告客户资源；",
              "3.通过沟通能够准确把握广告主需求，并与公司现有的资源进行整合，以实现整合营销；",
              "4.负责海外市场相关信息的收集、分析、整理汇报工作；",
              "5.推进合作合同的签订、回款等工作。",
            ],
            requirement: [
              "1.本科及以上学历，1年以上海外互联网广告销售经验优先；",
              "2.热衷移动互联网行业，对移动互联网广告行业有深入了解，熟悉海外推广；",
              "3.强烈的责任心，对金钱有一定的欲望，渴望成功，自我驱动力强；",
              "4.形象气质佳，头脑灵活，交际能力强；",
              "5.具有良好的英语口语沟通能力，能够熟练运用英语进行交流沟通及商务洽谈；",
              "6.有国内出海广告主资源者优先。",
            ],
            place: ["北京总部：北京市丰台区汉威国际广场三区一号楼9M层"],
          },
        ],
        [
          {
            name: "3D资深美术指导（北京）",
            duty: [
              "1.负责游戏项目产品的品宣设计，以视频制作为主（CG向）；",
              "2.负责对游戏项目的整体把控，分节点的推进，按时完项；",
              "3.负责对游戏项目的有效复盘与总结，总结出可复制的视频制作方法论；",
              "4.负责开展的设计人员的定期培训，提升设计人员的审美与技术能力；",
              "5.与部门内部人员的头脑风暴与新项目的研究与落地。",
            ],
            requirement: [
              "1.无论实操或者理论有自己完整的美学构建体系，且设计工作经验不少于8年，能力超群可适当放宽，有知名游戏公司任职经验优先考虑；",
              "2.拥有丰富的美术经验与技术积累，对游戏视频设计，尤其是三维建模、动画、动效、渲染等精通，对整体项目有着突出的审美能力与把控能力；",
              "3.独自操盘或者主导过游戏CG向的优质项目，能够评定项目中设计可行性以及制作周期，能够对项目进行合理分拆，也能带引下属熟练掌握设计规范；",
              "4.美术执行功底深厚、综合设计能力优秀，对于3Dmax、maya、c4D、unity、Ae等设计软件熟练运用，另平面设计软件也精通的加分；",
              "5.本科以上学历，服从上级安排，对工作认真负责，能够适应高强度的加班。",
            ],
            place: ["北京总部：北京市丰台区汉威国际广场三区一号楼9M层"],
          },
          {
            name: "游戏视频素材设计师（北京）",
            duty: [
              "1.负责游戏产品的视频广告制作与设计工作；",
              "2.能根据游戏录屏、原画、真人实拍视频及游戏类CG动画等素材进行后期合成及特效包装；",
              "3.针对国内或海外游戏投放渠道，产出广告视频的创意构思和设计。",
            ],
            requirement: [
              "1.影视制作、艺术设计、动画等相关专业，2年以上游戏视频制作、包装工作经验；",
              "2.熟悉视频后期制作软件工具（Nuke、AE，MAYA，PS等等），熟练使用特效插件实现效果，熟悉常用视频格式的导出、转换；",
              "3.对画面整体视觉及节奏效果有较好的创意及设计水平;",
              "4.本科以上学历，3年工作经验左右。",
            ],
            place: ["北京总部：北京市丰台区汉威国际广场三区一号楼9M层"],
          },
        ],
      ],
    };
  },

  props: {},

  components: {},

  computed: {},

  watch: {},

  filters: {},

  created() { },

  updated() { },

  mounted() { },

  destroyed() { },

  methods: {},
};
</script>
<style lang='less' scoped>
.joinus_index {
  background: #fff;
  .banner {
    width: 100%;
    height: 480px;
    background: url("./join.png") no-repeat center;
    background-size: cover;
  }
  .center {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 5;
  }
  .title_box {
    padding: 100px 0 32px;
    text-align: center;
    position: relative;
  }
  .title_box h3 {
    height: 74px;
    line-height: 74px;
    font-size: 44px;
    color: #1f1f1f;
    font-weight: normal;
  }
  .title_box p {
    line-height: 47px;
    font-size: 18px;
    color: #525252;
  }
  .title_box i {
    width: 60px;
    height: 4px;
    background: #1cabeb;
    margin: 0 -30px;
    position: absolute;
    left: 50%;
    bottom: 0;
  }
  .title_h1 {
    height: 127px;
    line-height: 127px;
    font-size: 40px;
    color: #1f1f1f;
    font-weight: normal;
    text-align: center;
    letter-spacing: 3px;
  }
  .join_reason {
    width: 862px;
    margin: 35px auto 60px;
    overflow: hidden;
  }
  .join_reason span {
    float: left;
  }
  .join_reason span img {
    float: left;
    display: block;
  }
  .join_us_text {
    display: flex;
    justify-content: space-between;
  }
  .join_us_text .font_module {
    width: 410px;
    overflow: hidden;
  }
  .join_us_text .module_l {
    //float: left;
    margin-left: 95px;
  }
  .join_us_text .module_r {
    //float: right;
    margin-right: 95px;
  }
  .join_us_text h3 {
    height: 69px;
    line-height: 69px;
    font-size: 20px;
    color: #1f1f1f;
    font-weight: bold;
  }
  .join_us_text h5 {
    height: 27px;
    line-height: 27px;
    font-size: 16px;
    color: #1f1f1f;
    font-weight: bold;
    margin-top: 30px;
  }
  .join_us_text p {
    line-height: 28px;
    font-size: 16px;
    color: #575757;
  }
  .join_us_text_box {
    margin-bottom: 60px;
    padding-bottom: 65px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
  }
  .email_adress {
    height: 49px;
    line-height: 49px;
    padding-bottom: 70px;
    font-size: 24px;
    text-align: center;
    color: #666;
    a {
      color: red;
      font-size: 18px;
    }
  }
}
</style>
<style lang='less' >
</style>



// WEBPACK FOOTER //
// src/page/joinus/index.vue